module.exports = __webpack_public_path__ + "img/s27.53ce141.png";